import type { RootState } from '@/app/store';

export const selectAuth = (s: RootState) => s.auth;
export const selectUser = (s: RootState) => s.auth.user;
export const selectAuthReady = (s: RootState) => s.auth.bootstrapped && !s.auth.loading;
